import { CSSProperties } from 'react';
import { withIcon } from './withIcon';

const LeftArrowSvg = ({ style }: { style?: CSSProperties }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clipPath="url(#clip0_554_2050)">
        <path d="M6.64508 14.619C6.38172 14.6153 6.13054 14.5076 5.94619 14.3195L0.295313 8.67858C-0.0961633 8.2903 -0.0987607 7.65815 0.289527 7.26664C0.291433 7.2647 0.293373 7.26277 0.295313 7.26086L5.94622 1.61997C6.36502 1.26131 6.99529 1.31007 7.35395 1.7289C7.67405 2.10269 7.67405 2.65395 7.35395 3.02771L2.41192 7.96974L7.40386 12.9118C7.79097 13.3012 7.79097 13.9301 7.40386 14.3195C7.20512 14.5228 6.92914 14.6318 6.64508 14.619Z" />
        <path d="M15.0012 8.96848H1.02379C0.472398 8.96848 0.0253906 8.52148 0.0253906 7.97008C0.0253906 7.41869 0.472398 6.97168 1.02379 6.97168H15.0012C15.5526 6.97168 15.9996 7.41869 15.9996 7.97008C15.9996 8.52148 15.5526 8.96848 15.0012 8.96848Z" />
      </g>
      <defs>
        <clipPath id="clip0_554_2050">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LeftArrow = withIcon(LeftArrowSvg);
